import { faArrowLeft, faHome } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { type ReactNode } from "react";

import { Button } from "~/components";
import { cn } from "~/lib/utils";
import { T } from "@repo/transifex";
import { collectActions } from "~/providers/store/collect/actions";
import { employeeActions } from "~/providers/store/employee";
import { useCollectFlow } from "~/providers/store/collect/hooks";
import { CollectLeaveGuard } from "~/components/pos/collect/collect-leave-guard";

import { useCollectTillContext } from "../__app.collect/collect-till-context";

type OrderDetailsPageLayoutProps = {
  className?: string;
  leftColumn: ReactNode;
  rightColumn?: ReactNode;
};

export const OrderDetailsPageLayout = ({
  className,
  leftColumn,
  rightColumn
}: OrderDetailsPageLayoutProps) => {
  const navigate = useNavigate();
  const collectFlow = useCollectFlow();
  const tillType = useCollectTillContext((till) => till.type);

  const shouldGoBackToPos =
    (collectFlow === "pos" || collectFlow === "collect-pos") &&
    tillType === "collect";

  return (
    <div className={cn("flex size-full flex-1 flex-row", className)}>
      <div className="flex flex-[1.5] flex-col">
        <div className="py-3">
          <Button
            icon={<FontAwesomeIcon icon={faArrowLeft} />}
            variant="transparent"
            className="text-base font-normal text-interface-warning-4"
            onClick={() => {
              if (shouldGoBackToPos) {
                navigate("/pos/sell", { replace: true });
              } else {
                navigate("/collect", { replace: true });
                employeeActions.reset();
                collectActions.reset();
              }
            }}
          >
            {shouldGoBackToPos ? <T _str="Back to POS" /> : <T _str="Back" />}
          </Button>
        </div>

        <div className="flex flex-1 justify-center px-16">{leftColumn}</div>

        <div className="h-16 p-2">
          <CollectLeaveGuard>
            <Button
              icon={<FontAwesomeIcon icon={faHome} />}
              variant="transparent"
              className="font-normal text-interface-warning-4"
              onClick={() => {
                collectActions.resetAllFilters();
                navigate("/home", { replace: true });
              }}
            >
              <T _str="Home" />
            </Button>
          </CollectLeaveGuard>
        </div>
      </div>

      {rightColumn ? <div className="flex flex-[2]">{rightColumn}</div> : null}
    </div>
  );
};
